<template>
  <section class="product-btm" id="more-info">
    <div class="inner">
      <div class="col col-2 padded" v-if="misc && misc.info_sections">
        <template v-for="(section, index) in misc.info_sections">
          <a :key="section._id + 'text'" class="product-info-link" href>{{section.text}}</a>
          <div :class="index == 0 ? 'default' : ''" :key="section._id + 'content'" class="product-info-section" v-html="section.content"></div>
        </template>
        <a class="config-buy" href="#configure">
          <img alt="Configure and buy" src="../assets/ripple.svg"> Configure &amp; buy online
        </a>
      </div>
      <div class="col col-2 padded" v-if="gallery">
        <img :alt="selectedImage.alt || page.name" :src="selectedImage.image" v-if="selectedImage">
        <div class="thumbs">
          <a :key="image._id" @click.prevent="selected_image = image" href v-for="image in gallery.slice(0,3)">
            <img :alt="image.alt || page.name" :src="image.image" class="product-img">
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "ProductBottom",
  data() {
    return { selected_image: null }
  },
  computed: {
    ...mapState(["page", "misc", "gallery"]),
    selectedImage: function() {
      if (this.selected_image) return this.selected_image
      if (this.gallery && this.gallery.length) return this.gallery[0]
      return null
    }
  }
}
</script>

<style scoped>
/* #region Product Bottom */

.product-btm {
  clear: both;
  padding: 5rem 0;
}

/* #endregion */

/* #region Accordion */

.product-info-section {
  display: none;
  padding: 1rem 2rem;
}

.product-info-section.default {
  display: block;
}

.product-info-link {
  display: block;
  background-color: #f5f5f5;
  font-size: 2rem;
  padding: 1rem 2rem;
  margin-top: 2px;
}

.product-info-link:hover {
  background-color: #e6e6e6;
}

/* #endregion */

@media screen and (max-width: 750px) {
}
</style>
